import BenefitCard from "@/components/benefit-card/benefit-card";
import CollectibleCard from "@/components/collectible-card/collectible-card";
import { claimBenefit } from "@/services/benefits/benefit";
import { getError } from "@/utils/get-error/get-error";
import { message } from "antd";
import { useCallback, useState } from "react";
import { TypeBenefitProps } from "./type-benefit-type";
import ClaimButtonNFT from "../claim-button-nft/claim-button-nft";
import { amplitudeAddTrack } from "@/utils/amplitud/event-track";
import { useNavigate } from "react-router-dom";

const ALLOWED_TYPES = ['PHYSICAL', 'ERC20', 'ERC721'];

const COMPONENT_BY_TYPE = {
  ERC20: CollectibleCard,
  ERC721: CollectibleCard,
  PHYSICAL: BenefitCard
} as const;

const TypeBenefit: React.FC<TypeBenefitProps> = ({
  benefit,
  isCompleted,
  isLoad,
  idMission,
  userMainKey,
  isClaimed,
  typeObjective,
  setIsClaimed
}) => {
  const { reward, benefit_amount_to_win } = benefit;
  const { reward_type, thumb_url, name, description } = reward;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [successClaim, setSuccessClaim] = useState<boolean>(false);

  const handleClaim = useCallback(async () => {
    try {
      setIsLoading(true);
      const body = {
        mission_id: idMission,
        user_main_key: userMainKey,
      }
      const response = await claimBenefit(body);
      setSuccessClaim(Array.isArray(response?.success) && response?.success.length > 0);
      amplitudeAddTrack('Claim Benefit', {
        mission_id: idMission,
        user_main_key: userMainKey,
        success: Array.isArray(response?.success) && response?.success.length > 0,
      });
      setIsClaimed(true)
    } catch (error) {
      console.error(error);
      if (error instanceof Error) {
        message.error(getError(error));
      } else {
        message.error('An unknown error occurred');
      }
    } finally {
      setIsLoading(false);
    }
  }, [idMission, userMainKey, setIsClaimed]);

  const handleGoWallet = useCallback(() => {
    navigate(`/wallet`);
  }, [navigate]);

  if (!ALLOWED_TYPES.includes(reward_type)) {
    return <div>Benefit type {reward_type} not supported</div>;
  }

  const newTypeReward = typeObjective === 'EXCHANGE' ? 'PHYSICAL' : reward_type;
  const Component = COMPONENT_BY_TYPE[newTypeReward];
  const ComponentProps = {
    thumb_url,
    title: name,
    name,
    src: thumb_url,
    benefit,
    description,
    reward_type: newTypeReward,
    benefit_amount_to_win,
    showIconNumber: true,
    onClick: successClaim || isClaimed ? handleGoWallet : () => {},
    typeClick: 'mission-page'
  }

  const text1 = isLoad ? 'Validando...' : 'Redimiendo...'
  const loadingButton = isLoad || isLoading;
  const isTextValidating = loadingButton ? text1 : 'Redimir';
  const textButton = successClaim || isClaimed ? 'Redimido' : isTextValidating;
  const disabledButton = !isCompleted || isLoad || successClaim || isClaimed;

  return (
    <Component {...ComponentProps} >
      {typeObjective !== 'EXCHANGE' &&
        <ClaimButtonNFT
          rewardType={reward_type}
          isClaimed={successClaim || isClaimed}
          disabled={disabledButton}
          loading={loadingButton}
          onClick={handleClaim}
          highlight={!disabledButton && !loadingButton}
        >
          {textButton}
        </ClaimButtonNFT>
      }
    </Component>
  );
};

export default TypeBenefit;
